export enum EAppointmentCategory {
  Consultation = 1,
  Exam = 2
}
